// Helper normalisasi data `permissions` dari inits (/WA/inits).
//
// Backward-compatible: menerima DUA bentuk lalu selalu mengembalikan flat
// array nama permission yang unik.
//   - Flat (baru, permission_list=1): ["dashboard", "contacts", "contacts_add"]
//   - Nested (lama): [{ name, title, child: [{ name, ... }] }]
//
// Dengan begini seluruh konsumen cukup memakai `names.includes(name)` tanpa
// peduli format mana yang sedang dikirim server.
//
// ===========================================================================
// PANDUAN CLEANUP — cleanup-permission-legacy
// ===========================================================================
// Dukungan format lama ini SEMENTARA, supaya FE tidak tergantung urutan deploy
// BE. Setelah BE format izin baru naik di SEMUA environment (dev, staging,
// produksi) dan sudah stabil, dukungan format lama boleh dihapus.
//
// Cara menemukan semua titiknya:
//   grep -rn "cleanup-permission-legacy" src
//
// Yang harus dilakukan saat cleanup:
//   1. src/utils/permission.js — `flattenPermissionNames`: buang cabang objek
//      (`item?.name` + rekursi `child`), sisakan penanganan item string saja.
//   2. src/components/apps/settings/Roles/RoleForm/index.jsx
//      a. `getPermissionKey`: buang fallback `?? node?.id`.
//      b. `resolveRolePermissionKeys`: buang cabang objek, sisakan lookup
//         `nameKeyMap[item]` untuk item string.
//      c. `filter((key) => key != null)`: boleh disederhanakan kembali jadi
//         `filter(Boolean)` karena key sudah pasti string enum, bukan angka.
//
// JANGAN dihapus saat cleanup:
//   - `permission_list: 1` di src/config/inits.js — itu parameter opt-in ke BE,
//     bukan kode kompatibilitas. Hapus HANYA kalau BE sudah menjadikan format
//     flat sebagai default tanpa perlu parameter (konfirmasi ke tim BE dulu).
//   - `permissionsSelector` di src/redux/selectors.js — masih dipakai sebagai
//     sumber `permissionNamesSelector` dan untuk deteksi "inits belum termuat"
//     di src/hooks/useCheckPermissionPage.js.
// ===========================================================================
export const flattenPermissionNames = (raw = []) => {
  const out = [];

  const walk = (list) => {
    if (!Array.isArray(list)) return;
    list.forEach((item) => {
      if (typeof item === "string") {
        out.push(item);
      } else if (item?.name) {
        // cleanup-permission-legacy: cabang format nested lama.
        out.push(item.name);
        if (item.child) walk(item.child);
      }
    });
  };

  walk(raw);
  return Array.from(new Set(out));
};

// Bentuk objek aksi untuk useModulePermissions. Kontrak lama dijaga:
// - isCanAdd / isCanEdit / isCanDelete / isCanReconciliation / isCanConversionBalance
// - plus key dinamis per nama permission (mis. actions.task_list, actions.wa_blast_add,
//   actions.meeting_schedule_all) supaya pemakaian lama tetap jalan.
export const buildModuleActions = (names = [], moduleName) => {
  const has = (name) => names.includes(name);

  const actions = {
    isCanAdd: has(`${moduleName}_add`),
    isCanEdit: has(`${moduleName}_edit`),
    isCanDelete: has(`${moduleName}_delete`),
    isCanReconciliation: has(`${moduleName}_reconcile`),
    isCanConversionBalance: has("conversion_balance"),
  };

  names.forEach((name) => {
    actions[name] = true;
  });

  return actions;
};
